import axiosClient from "config/axiosClient"
import { IResponseService } from "interfaces/IResponseService"
import { ISource } from "interfaces/ISource"
import configEnv from "config/configEnv"
import { AxiosResponse, CancelToken } from "axios"

const clientAxios = axiosClient("OIM")

export const getSourceInfoById = async (
  sourceId: string,
  cancelToken: CancelToken,
): Promise<AxiosResponse<IResponseService<ISource>>> => {
  const client = clientAxios.getClient()

  const url = `${configEnv.urlSources}`
  const requestBody = {
    idsOrAliases:[sourceId],
    project: ["id", "name", "custom"]
  }

  const response = await client.post<IResponseService<ISource>>(
    url, requestBody, {
    headers: { "Content-Type": "application/json" },
    data: {},
    cancelToken,
  })

  return response
}
